import { Error, Lock, LockOpen, Schedule, Warning } from '@sparkpost/matchbox-icons';

export const TLS_STATUS_CONFIG = {
  valid: {
    color: 'green',
    icon: Lock,
    label: 'Valid',
    tooltip: 'This domain has a valid TLS certificate'
  },
  pending: {
    color: 'blue',
    icon: Schedule,
    label: 'Pending',
    tooltip: 'Certificate provisioning in progress. This may take several minutes'
  },
  unavailable: {
    color: undefined,
    icon: LockOpen,
    label: 'Inactive',
    tooltip: 'TLS is unavailable for this domain at the moment.'
  },
  'acme:caa_forbidden': {
    color: 'red',
    icon: Error,
    label: 'Action Required',
    tooltip:
      "Certificate provisioning failed. Please add a CAA record at your DNS provider allowing Let's Encrypt to issue a certificate for this domain.",
    isError: true
  },
  'dns:incorrect_cname': {
    color: 'red',
    icon: Error,
    label: 'Action Required',
    tooltip:
      'Certificate provisioning failed. Please update the CNAME record at your DNS provider and verify the domain.',
    isError: true
  }
};

export const UNKNOWN_ERROR_CONFIG = {
  color: 'red',
  icon: Error,
  label: 'Error',
  tooltip:
    'Certificate provisioning failed due to an internal error. Please contact support for assistance.',
  isError: true
};

export const EXPIRED_DISPLAY = {
  color: 'yellow',
  icon: Warning,
  label: 'Expired',
  tooltip: 'Certificate expired. Renewal failed'
};
